/* Pocket Option referral links for registration. The main domain is
   blocked by Russian ISPs, so users there get a mirror with the same
   affiliate parameters. */
export const REG_LINK = "https://u3.shortink.io/register?utm_campaign=59203&utm_source=affiliate&utm_medium=sr&a=ClUUK33EsXNshv&al=1809375&ac=jotrade_pro&cid=990085";
export const REG_LINK_RU = "https://po-ru4.click/register?utm_campaign=59203&utm_source=affiliate&utm_medium=sr&a=ClUUK33EsXNshv&al=1809375&ac=jotrade_pro&cid=990085";

// There's no country in the app, so the device timezone is the hint.
// A wrong guess is covered by the alternative link under the button.
const RU_TIMEZONES = new Set([
  "Europe/Kaliningrad", "Europe/Moscow", "Europe/Kirov", "Europe/Volgograd", "Europe/Astrakhan",
  "Europe/Saratov", "Europe/Ulyanovsk", "Europe/Samara", "Asia/Yekaterinburg", "Asia/Omsk",
  "Asia/Novosibirsk", "Asia/Barnaul", "Asia/Tomsk", "Asia/Novokuznetsk", "Asia/Krasnoyarsk",
  "Asia/Irkutsk", "Asia/Chita", "Asia/Yakutsk", "Asia/Khandyga", "Asia/Vladivostok",
  "Asia/Ust-Nera", "Asia/Magadan", "Asia/Sakhalin", "Asia/Srednekolymsk", "Asia/Kamchatka", "Asia/Anadyr",
]);

export function isRussianTimezone() {
  try {
    return RU_TIMEZONES.has(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch (e) {
    return false;
  }
}
